module.exports = __webpack_public_path__ + "img/stock5.43f100b6.png";